// Course slug helpers, shared by the Add and Update Course forms.
//
// The slug is the course's page address on the public website:
//   https://myskillverse.ai/courses/<slug>
// The website fetches a course BY this value, so a course without one lists on
// the landing page but links to /courses/undefined.
//
// Keep SLUG_PATTERN and SLUG_MAX in step with validateCourseSlug in the Admin
// backend's courseController.js — the server is the authority (it also checks
// uniqueness, which only it can), this copy just lets the form answer before a
// round trip.

export const WEBSITE_COURSE_URL = "https://myskillverse.ai/courses/";
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const SLUG_MAX = 120;

// "AI/ML Bootcamp with Placement Training" -> "ai-ml-bootcamp-with-placement-training"
export const slugify = (text) =>
  String(text || "")
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")   // strip accents: "é" -> "e"
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")       // anything else becomes a single hyphen
    .replace(/^-+|-+$/g, "")
    .slice(0, SLUG_MAX)
    .replace(/-+$/g, "");              // slicing can leave a trailing hyphen

// A message for the field, or "" when the slug is acceptable locally.
export const slugError = (slug) => {
  const s = String(slug || "").trim();
  if (!s) return "Course slug is required — it is the course's page address on the website";
  if (s.length > SLUG_MAX) return `Course slug must be ${SLUG_MAX} characters or fewer`;
  if (!SLUG_PATTERN.test(s)) return "Use lowercase letters, numbers and single hyphens only, e.g. ai-ml-placement-training";
  return "";
};
